define(['jquery'],
    function($) {
        //var loading_spinner = '<div class="nexto-spinner"><div class="square c1"></div><div class="square c2"></div><div class="square c3"></div><div class="square c4"></div><div class="square c5"></div><div class="square c6"></div><div class="square c7"></div><div class="square c8"></div><div class="square c9"></div><div class="square c10"></div><div class="square c11"></div><div class="square c12"></div><div class="square c13"></div><div class="square c14"></div><div class="square c15"></div></div>';
        let loaderElement = document.querySelector(".marketing-loader");

        if(!loaderElement) return;
        
        return {
            start: function() {
                $('.hidden-while-loading').removeClass('loading-complete');
                loaderElement.classList.remove("disabled");
            },

            complete: function() {
                loaderElement.classList.add("disabled");
                $('.hidden-while-loading').addClass('loading-complete');
                $(document).trigger('smileback.loading.done');
            }
        };
    }
);
